<template>
  <b-modal
    :title="'Migrar del Rol: ' + rol.nombre"
    ref="modalMigrationRol"
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
  >
    <b-overlay :show="isSaving">
      <div class="row">
        <div class="col-md-12">
          <label>Ambiente destino</label>
          <v-select
            v-model="enviromentSelected"
            multiple
            label="title"
            :options="enviromentAvailable"
          />
        </div>
        <div class="col-md-12 mt-5">
          <button
            :disabled="enviromentSelected.length === 0"
            class="btn btn-primary"
            @click="sendMigration"
          >
            Guardar
          </button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

import { applications, webSopes } from '@/febos/global/utils/configurations';
import {
  ioMigrateCompanyRolPermission
} from '@/febos/servicios/api/empresas.api';

const availableEnvironment = [
  { title: 'Desarrollo', value: 'desarrollo' },
  { title: 'Pruebas', value: 'pruebas' },
  { title: 'Certificación', value: 'certificacion' },
  { title: 'Produccion', value: 'produccion' }
];

export default {
  name: 'RolMigrationModal',
  data() {
    return {
      applications,
      webSopes,
      filter: '',
      enviromentSelected: [],
      isSaving: false,
      rol: {}
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    enviromentAvailable() {
      return availableEnvironment.filter((env) => env.value !== process.env.VUE_APP_AMBIENTE);
    }
  },
  methods: {
    async sendMigration() {
      this.isSaving = true;
      const environment = this.enviromentSelected.map((permission) => (
        permission.value
      ));
      const { rol } = this;
      try {
        await ioMigrateCompanyRolPermission(this.company.id, rol.rolId, environment);
        this.$emit('saveMigrationRol', this.rol);
        this.$refs.modalMigrationRol.hide();
        this.isSaving = false;
      } catch (e) {
        console.error(e);
        this.isSaving = false;
      }
    },
    async open(rol) {
      this.rol = rol;
      this.enviromentSelected = [];
      this.$refs.modalMigrationRol.show();
    },
    hide() {
      this.$refs.modalMigrationRol.hide();
    }
  }
};
</script>
